import React, { useMemo,  useContext, useState, useEffect } from 'react';
import siblingPlaceholder from './assets/sibling-placeholder.png';
import calendarPlaceholder from './assets/calendar-placeholder.png';
import cardPlaceholder from './assets/card-placeholder.png';
import ornamentPlaceholder from './assets/ornament-placeholder.png';
import magnetPlaceholder from './assets/magnet-placeholder.png';
import styles from './HolidayBuilder.module.scss';
import DisplayableSheet from '../../../PackageBuilders/MultiPose/DisplayableSheet';
import { addonSheetToSheet } from '../../../PackageBuilders/MultiPose/functions';
import Image from "../../../Image";
import defaultBackground from "../../../../assets/Package_Blue.png";
import blackImage from './assets/PromoImage_Slide_1_Black.jpg';

import plaidBackground from './assets/Senior_Grey.jpg';
import SchoolAnnouncementThumbnail from './SchoolAnnouncementThumbnail';
import { CURSIVE_BASE_URL, CURSIVE_OVERLAY_URL as cursiveForeground } from './announcementThumbnail';
import { CustomerContext } from '../../../../contexts/CustomerContext';
import reportUnknownAddonVariant from '../../../../utils/addonPreviewVariant';
import axios from 'axios';
import '../../../../fonts/fonts.scss';

// Variants that draw the portrait itself rather than compositing it into a
// product mockup, and so need no `addon.imageUrl`. Keep this in step with the
// cases below that ignore `addon.imageUrl`.
const SELF_DRAWING_VARIANTS = ['digitalfile'];

export default function Item({ siblingProps, addon, variant, titleText, subtitleText, onClick = () => {}, pose, background }) {
  const { customer } = useContext(CustomerContext);
  const [studentData, setStudentData] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);

  const [componentWidth, setComponentWidth] = useState(0);

useEffect(() => {
  const updateWidth = () => {
    const element = document.getElementById('item-wrapper');
    if (element) {
      const width = element.getBoundingClientRect().width;
      setComponentWidth(width);
    } else {
    }
  };

  setTimeout(updateWidth, 100);

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      setComponentWidth(entry.contentRect.width);
    }
  });

  const element = document.getElementById('item-wrapper');
  if (element) {
    resizeObserver.observe(element);
  }

  window.addEventListener('resize', updateWidth);

  return () => {
    window.removeEventListener('resize', updateWidth);
    resizeObserver.disconnect();
  };
}, []);

  const renderImageComponent = () => {
    switch (variant) {
      case 'ornament':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.ornament}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'gradannouncementregular':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradannouncementregular}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
        case 'gradbrown':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradbrown}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'gradplaid':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradplaid}>
              
              <Image src={plaidBackground} alt=""/>
              <Image src={pose?.watermarkUrl} alt="" classes={styles.gradplaidForeground}/>
            </div>
          </div>
        )
        case 'gradcursive':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={CURSIVE_BASE_URL} alt="" classes={styles.packageImage} />
            <Image src={cursiveForeground} alt="" classes={styles.gradcursiveForeground}/>
            <div className={styles.gradcursive}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
        case 'gradclassicvert':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradclassicvert}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'gradannouncement':
        return (
          <div className={styles.itemImgWrapper}>
            <SchoolAnnouncementThumbnail
              poseUrl={pose?.watermarkUrl}
              fallbackSrc={blackImage}
              classes={styles.packageImage}
            />
            <div className={styles.gradannouncement}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'card':
        return cardPlaceholder;
      case 'keychain':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.poseOneKeychain}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'magnet':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.poseOneMagnet}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
            <div className={styles.poseTwoMagnet}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        );
        case 'calendar':
          return (
            <div className={styles.itemImgWrapper}>
              <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
              
              <div className={styles.calendar}>
                <Image src={pose?.watermarkUrl} alt=""/>
              </div>
            </div>
          );

          case 'eightbytenG':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.eightbytenG}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );

        // A DIGITAL FILE IS NOT A PRINT, and must not borrow eightbytenG's
        // frame to say so: the two sit side by side on this page at different
        // prices, and the same 8x10 mockup on both sells a download as a
        // photograph.
        //
        // Every other variant composites the pose INTO a photograph of a
        // physical product. There is no product to photograph here, and the
        // add-on carries no image to fall back on -- so this draws the
        // portrait itself, which is literally what the customer receives.
        case 'digitalfile':
          return (
            <div className={styles.itemImgWrapper}>
              <div className={styles.digitalfile}>
                <Image src={pose?.watermarkUrl} alt="" />
              </div>
            </div>
          );
            case 'coffeecup':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.coffeecup}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
          case 'fivebyseven':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.poseOnefivebyseven}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseTwofivebyseven}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
          case 'threebyfive':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.poseOnethreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseTwothreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseThreethreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseFourthreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
          case 'wallets':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.poseOneWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseTwoWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseThreeWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseFourWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>

                <div className={styles.poseFiveWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseSixWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseSevenWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseEightWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
      case 'plaque':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.poseOnePlaque}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        );
      default:
        // A css_name no preview knows (a print-template code like `T810`, a typo).
        // Draw the add-on's own product image so the card is visible and clickable
        // instead of an empty box — the pose overlay needs per-variant geometry
        // that doesn't exist for an unknown value. See utils/addonPreviewVariant.
        reportUnknownAddonVariant(addon, variant);

        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
          </div>
        );
    }
  }

  const sheets = useMemo(() => {
    if (variant !== 'sibling') return [];

    return siblingProps.addons.map((addon) => addonSheetToSheet({ addon, background: siblingProps.background, pose: siblingProps.pose }));
  }, [variant, siblingProps]);

  return (
    <button className={styles.item} type="button" onClick={onClick}>
      <div id="item-wrapper" className={styles.itemImgWrapper}>
        {/* ⚠️ `addon.imageUrl &&` GATES THE WHOLE PREVIEW. Every variant here
            composites the pose into a photograph of a physical product, so an
            add-on with no product photo drew an empty box whatever its
            css_name -- which is why "Digital File" could not have been shown on
            this page even with a correct variant.

            SELF_DRAWING_VARIANTS are the exception: they ARE the portrait and
            have no product to photograph, so they must render without one. */}
        {variant !== 'sibling'
          && (addon.imageUrl || SELF_DRAWING_VARIANTS.includes(variant))
          && renderImageComponent()}
        {/*{variant === 'sibling' && sheets.map((sheet) => <DisplayableSheet sheet={sheet} />)}*/}
      </div>
      <div className={styles.titlesWrapper}>
        <span className={styles.title}>{titleText}</span>
        <span className={styles.subtitle}>{subtitleText}</span>
      </div>
    </button>
  );
}
